"use client";

import { useState, MouseEvent } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import axios from "axios";

import { useStyles } from "./styles";
import { useAppSelector } from "@/redux/store";
import Shortcut from "../Shortcut";
import Modal from "@/components/common/Modal";
import TextField from "@/components/common/TextField";
import Button from "@/components/common/PrimaryButton";
import OutlinedIcon from "@/components/icons/PaymentsOutlined";
import FilledIcon from "@/components/icons/Payments";

const Monetization = () => {
  const { classes } = useStyles();
  const pathname = usePathname() as string;
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [trafficSources, setTrafficSources] = useState("");
  const user = useAppSelector((state) => state.user.user);
  const [error, setError] = useState("");

  const handleModalOpen = () => {
    setOpen(true);
  };

  const handleModalClose = () => {
    setOpen(false);
  };

  const handleViewCreatorPage = () => {
    if (typeof window !== "undefined") {
      window.open("https://idyllic.app/idyllic-quiz/", "_blank");
    }
  };

  const handleSubmit = async (e: MouseEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError("");

    if (process.env.NODE_ENV === "production") {
      try {
        const reqBody = {
          name,
          trafficSources,
        };
        await axios.post(
          `${process.env.NEXT_PUBLIC_API_URL}/creator/welcome`,
          reqBody,
          {
            withCredentials: true,
          }
        );
        if (typeof window !== "undefined") {
          window.open("https://idyllic.app/idyllic-quiz/", "_blank");
        }
        handleModalClose();
      } catch (error: unknown) {
        setError("Failed to submit application. Please try again.");
        console.error(error);
      }
    }

    setLoading(false);
  };

  return (
    <>
      <Shortcut
        url={pathname} // Temporary until new page is made...
        icon={<OutlinedIcon />}
        activeIcon={<FilledIcon />}
        label="Monetization"
        onClick={handleModalOpen}
      />
      <Modal open={open} onClose={handleModalClose}>
        <div className={classes.modalContent}>
          <div className={classes.modalHeading}>
            <h2>Quiz Monetization</h2>
            <FilledIcon />
          </div>

          <p className={classes.modalDescription}>
            {user ? (
              `Are you a creator or community owner looking to monetize and engage
            your audience with Idyllic Quizzes? Submit your details to learn
            more about our partner program. Provide as much detail as you can,
            so we can process your application faster.`
            ) : (
              <span>
                Please sign in or create a free account to join our creator
                platform. In the meantime, you can read about monetization via
                our quiz partner programme{" "}
                {
                  <a href="https://idyllic.app/idyllic-quiz/" target="_blank">
                    here
                  </a>
                }
                .
              </span>
            )}
          </p>
          {user ? (
            <form className={classes.form} onSubmit={handleSubmit}>
              <TextField label="Name" value={name} onUpdate={setName} />
              <TextField
                label="Traffic Source(s)"
                value={trafficSources}
                onUpdate={setTrafficSources}
                placeholder="E.g. Links to pages / groups / servers / websites"
                multiline
                className={classes.textField}
              />
              {error && <p className={classes.errorMessage}>{error}</p>}
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                disabled={!name || !trafficSources}
                className={classes.submitButton}
                loading={loading}
              >
                Apply Now
              </Button>
              <p className={classes.footerText}>24hr approval time</p>
            </form>
          ) : (
            <div className={classes.buttons}>
              <Link href="/register">
                <Button>Sign Up</Button>
              </Link>
              <Button color="secondary" onClick={handleViewCreatorPage}>
                Find out more
              </Button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default Monetization;
